import WidgetLogoPresentation from 'components/WidgetLogo/WidgetLogoPresentation'

export default {
  Presentation: WidgetLogoPresentation,
}
